import React from 'react';
import classNames from 'classnames';
import { Presentation, ContentItemFragment, Accessibility } from 'app/graphql/__generated__/types/contento';
import AccessServiceTypes from 'app/domain/AccessServiceTypes';
import ContinueWatching from 'app/utils/models/ContinueWatching';
import { OnItemImpressionType } from 'app/utils/useTrackImpression';
import CarouselArrows from './components/CarouselArrows';
import ItemsList from './components/ItemsList';
import { Container, StyledCarousel } from './ContentItemCarousel.styles';
import { CardType } from '../ContentList/ContentList';

export const slugify = (text: string): string => {
    const slug = encodeURIComponent(
        text
            .toString()
            .toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(/[^\w-]+/g, '') // Remove all non-word chars
            .replace(/--+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, '')
    ); // Trim - from end of text

    return `id-${slug}`;
};

type Props = {
    items: Array<ContentItemFragment>;
    index?: number;
    editModeActivated?: boolean;
    location?: string;
    id?: string;
    presentation?: Presentation;
    cardType?: CardType;
    className?: string;
    dataRt?: string;
    preferredAccessVersion?: AccessServiceTypes;
    onItemClick?: (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        itemPosition: number,
        svtId: string,
        autoPlay: boolean,
        b: boolean
    ) => void;
    onItemImpression: OnItemImpressionType;
    onMarkItemAsDeleted?: (markedAsDeletedObject: ContinueWatching) => void;
    continueWatchingIsActive?: boolean;
    markedAsDeleted?: Array<ContinueWatching>;
    isInSweden?: boolean;
    currentAccessibilityChoiceContento?: Accessibility;
    autoPlay?: boolean;
    playingNowId?: string;
    linkToDetailsPage?: boolean;
    hasHero?: boolean;
};

const ContentItemCarousel = (props: Props): JSX.Element => {
    const { id = '', presentation, cardType, className, dataRt, index } = props;

    const carouselId = slugify(`core-carousel-${id}`);

    // do not add lp_classes to displaywindow-components
    const classes = classNames(className, { [`lp_${id}`]: !id.includes('recommended') });
    const carouselClass = id.includes('recommended') ? '' : `lp_list${index}` || '';

    return (
        <Container className={classes} data-rt={dataRt}>
            <>
                <CarouselArrows carouselId={carouselId} presentation={presentation} cardType={cardType} />
                <div
                    style={{
                        overflow: 'hidden',
                        position: 'relative',
                    }}
                >
                    <StyledCarousel id={carouselId} className={carouselClass} friction={0.8}>
                        <ItemsList
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...props}
                        />
                    </StyledCarousel>
                </div>
            </>
        </Container>
    );
};

export default ContentItemCarousel;
